<script setup lang="ts">
import OperationOfficeAutoComplete from "@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue";
import getOperationOffice from '@/types/responses/getOperationOffice';
import { computed } from 'vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: getOperationOffice | null
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
<template>
  <div class="w-100 mt-3">
    <div class="d-flex justify-end">
      <div class="w-25">
        <OperationOfficeAutoComplete
          v-model="modelValue"
        />
      </div>
    </div>
  </div>
</template>
